import {USER_ROOT_API_URL} from "../../../../config/settings.js"

export const GET_USER_PROFILE = USER_ROOT_API_URL + "/get_user_profile"
export const UPDATE_PROFILE = USER_ROOT_API_URL +  "/update_profile"